module.exports = __webpack_public_path__ + "assets/img/BodyLux-w720.aac21eeb.jpg";